// Minimal structured client logger. Rules (CLAUDE §3): NEVER log PII/tokens; in prod
// only warn/error reach the console. Callers pass non-PII context only; `redactKeys`
// is a backstop that strips obviously-sensitive keys if one slips through.
import { env } from "./env.ts";

type Level = "debug" | "info" | "warn" | "error";

const SENSITIVE = /(email|phone|token|secret|password|field_values|authorization|apikey)/i;

function redact(ctx: Record<string, unknown> | undefined): Record<string, unknown> | undefined {
  if (!ctx) return undefined;
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(ctx)) {
    out[k] = SENSITIVE.test(k) ? "[redacted]" : v;
  }
  return out;
}

function emit(level: Level, event: string, ctx?: Record<string, unknown>) {
  if (!env.isDev && (level === "debug" || level === "info")) return;
  const line = { level, event, ...redact(ctx) };
  const fn = level === "error" ? console.error : level === "warn" ? console.warn : console.log;
  fn(JSON.stringify(line));
}

export const logger = {
  debug: (event: string, ctx?: Record<string, unknown>) => emit("debug", event, ctx),
  info: (event: string, ctx?: Record<string, unknown>) => emit("info", event, ctx),
  warn: (event: string, ctx?: Record<string, unknown>) => emit("warn", event, ctx),
  error: (event: string, ctx?: Record<string, unknown>) => emit("error", event, ctx),
};
